import React from 'react';
import './index.css';

const ScenarioCard = ({ icon, title, description }) => {
  return (
    <div className="scenario-card">
      <div className="scenario-icon">
        <img src={icon} alt={title} className="scenario-icon-img" />
      </div>
      <div className="scenario-content">
        <h3 className="scenario-title">{title}</h3>
        <p className="scenario-description">{description}</p>
      </div>
    </div>
  );
};

export default ScenarioCard;
